import getMetaElements from "shared/components/MetaTags/getMetaElements"
import getMetaTagsString from "shared/components/MetaTags/getMetaTagsString"
import { getSmallestImage } from "./helpers/utils"

/**
 * функция отвечает за формирование шаблона в блоке head разметки
 */
export const getHeadTemplate = ({props, activeRoute, objProps }: any) => {
    const { designerRu, notFound } = props
    const { req } = objProps
    const hostOrig = req.get('host')
    const host = hostOrig.split('.')[0]
    const hostName = host ? host.charAt(0).toUpperCase() + host.slice(1) : ''
    if (!designerRu) return 
    const designerFullName = `${designerRu.name} ${designerRu.surName}`
    const designerAbout = designerRu.about
    // console.log('getHeadTemplate!!!', host, designerFullName);
    const pageTitle = notFound ? 'Пользователь не найден' : designerFullName ? `${designerFullName} на ${hostName}` : designerFullName
    const pageDescription = designerAbout   //возможно надо сюда тегов со страницы дизайнера добавить
    const ogUrl = `https://${hostOrig}${req.url}`
    const smallestImage = getSmallestImage(designerRu.avatar);
    const ogImage = smallestImage ? smallestImage.url : '';

    const imageUrl = `https://files.mediiia.ru/${ogImage}`

    const elements = getMetaElements({title: pageTitle, imageUrl, description: [pageDescription]})

    const metaTags = getMetaTagsString(elements)
    
    return `
        <title>${pageTitle}</title>
        ${metaTags}
    `
}import getMetaElements from "shared/components/MetaTags/getMetaElements"
import getMetaTagsString from "shared/components/MetaTags/getMetaTagsString"
import { getSmallestImage } from "./helpers/utils"

/**
 * функция отвечает за формирование шаблона в блоке head разметки
 */
export const getHeadTemplate = ({props, activeRoute, objProps }: any) => {
    const { designerRu, notFound } = props
    const { req } = objProps
    const hostOrig = req.get('host')
    const host = hostOrig.split('.')[0]
    const hostName = host ? host.charAt(0).toUpperCase() + host.slice(1) : ''
    if (!designerRu) return 
    const designerFullName = `${designerRu.name} ${designerRu.surName}`
    const designerAbout = designerRu.about
    // console.log('getHeadTemplate!!!', host, designerFullName);
    const pageTitle = notFound ? 'Пользователь не найден' : designerFullName ? `${designerFullName} на ${hostName}` : designerFullName
    const pageDescription = designerAbout   //возможно надо сюда тегов со страницы дизайнера добавить
    const ogUrl = `https://${hostOrig}${req.url}`
    const smallestImage = getSmallestImage(designerRu.avatar);
    const ogImage = smallestImage ? smallestImage.url : '';

    const imageUrl = `https://files.mediiia.ru/${ogImage}`

    const elements = getMetaElements({title: pageTitle, imageUrl, description: [pageDescription]})

    const metaTags = getMetaTagsString(elements)
    
    return `
        <title>${pageTitle}</title>
        ${metaTags}
    `
}